module.exports = __webpack_public_path__ + "static/enterprises-3-a75f12579eff2943b7f4f35680316ea0.png";